import Vue from "vue";
import axios from "axios";

Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
const getController = self.customSetting.getFileMgmt;
const postController = self.customSetting.postFileMgmt;

export default {
  // 5-5
  QryDocumentType: () => {
    return axios.get(`${baseApi}/${getController}/QryDocumentType`);
  },
  QryVendorDocument: (context, params) => {
    return axios.get(`${baseApi}/${getController}/QryVendorDocument?${params}`);
  },
  UploadDocument: (context, data) => {
    return axios.post(`${baseApi}/${postController}/UploadDocument`, data);
  },
  DeleteDocument: (context, data) => {
    return axios.post(`${baseApi}/${postController}/DeleteDocument`, data);
  },
};
